/* The screens' side of the unread marks (S10 part B). The list itself lives in
 * unread.js, which node tests load; this file needs the sign-in state. */

import { useEffect, useSyncExternalStore } from 'react';
import { useAuth } from '../auth/AuthContext.jsx';
import { refreshUnread, subscribeUnread, unreadNumbers } from './unread.js';

/** The current answer, read again when a screen opens and when the person comes back
 * to the browser tab. Only once sign-in is known: never while it is still being
 * checked, never when signed out. 'error' (no /.auth/me, local dev) still asks. */
export function useUnread() {
  const value = useSyncExternalStore(subscribeUnread, unreadNumbers, unreadNumbers);
  const { status } = useAuth();
  const enabled = status === 'authenticated' || status === 'error';
  useEffect(() => {
    if (!enabled) return undefined;
    refreshUnread();
    const again = () => {
      if (document.visibilityState === 'visible') refreshUnread();
    };
    window.addEventListener('focus', again);
    document.addEventListener('visibilitychange', again);
    return () => {
      window.removeEventListener('focus', again);
      document.removeEventListener('visibilitychange', again);
    };
  }, [enabled]);
  return value;
}
